import { render, staticRenderFns } from "./Spin.vue?vue&type=template&id=30cf15de&scoped=true"
import script from "./Spin.vue?vue&type=script&lang=js"
export * from "./Spin.vue?vue&type=script&lang=js"
import style0 from "./Spin.vue?vue&type=style&index=0&id=30cf15de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cf15de",
  null
  
)

export default component.exports